import Icon from 'veui/components/Icon'
import { IconRoad } from 'dls-icons-vue'

Icon.register('road', IconRoad)
